<template>
    <transition name="fade">
        <div class="body-1 pr-4" v-if="showform">
          <br>
          {{ $t('contacte[0].fraseformulari')}}
           <!--  Si prefieres, puedes enviarnos tus comentarios y te responderemos lo antes posible: --> <br>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'tenseFormIntroduction',
    props: {
        showform: Boolean,
    },
    components: {
    },
    data () {
      return {
      }
    }
}

</script>

<style>

  .fade-enter-active, .fade-leave-active {
    transition: opacity 3.2s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
    transition: opacity .8s;
  }

</style>